<script>
import {
    BCol, BFormGroup, BFormInput, BFormTextarea, BRow, BTab, BTabs,
} from 'bootstrap-vue'
import ExpressionInterpreter from '@core/components/common/expression-language/ExpressionInterpreter.vue'

let businessRuleExplanationId = 0

export default {
    components: {
        BCol,
        BFormGroup,
        BFormInput,
        BFormTextarea,
        BRow,
        BTab,
        BTabs,
        ExpressionInterpreter,
    },
    props: {
        rule: {
            required: true,
            type: Object,
        },
        languages: {
            required: true,
            type: Array,
        },
        explanation: {
            type: Object,
            default: null,
        },
    },
    data() {
        businessRuleExplanationId += 1

        return {
            expression: this.rule.expression,
            inputIdPrefix: `business-rule-explanation-${businessRuleExplanationId}`,
        }
    },
    watch: {
        rule() {
            this.expression = this.rule.expression
            this.ensureTranslations()
        },
        languages() {
            this.ensureTranslations()
        },
    },
    created() {
        this.ensureTranslations()
    },
    methods: {
        ensureTranslations() {
            if (!this.rule.translations) {
                this.$set(this.rule, 'translations', {})
            }

            this.languages.forEach(language => {
                if (!this.rule.translations[language.code]) {
                    this.$set(this.rule.translations, language.code, {
                        title: '',
                        description: '',
                    })
                }

                if (typeof this.rule.translations[language.code].title === 'undefined') {
                    this.$set(this.rule.translations[language.code], 'title', '')
                }

                if (typeof this.rule.translations[language.code].description === 'undefined') {
                    this.$set(this.rule.translations[language.code], 'description', '')
                }
            })
        },
        emit() {
            this.rule.expression = this.expression
            this.$emit('change', {
                expression: this.expression,
                rule: this.rule,
            })
        },
        inputId(field, language) {
            return `${this.inputIdPrefix}-${field}-${language.code}`
        },
    },
}
</script>

<template>
    <div>
        <b-row>
            <b-col>
                <b-tabs v-if="languages.length">
                    <b-tab
                        v-for="language in languages"
                        :key="language.code"
                        :title="language.code.toUpperCase()"
                    >
                        <b-form-group
                            :label="$t('Component(Label):name')"
                            :label-for="inputId('title', language)"
                        >
                            <b-form-input
                                :id="inputId('title', language)"
                                v-model="rule.translations[language.code].title"
                                :placeholder="$t('Component(Placeholder):type-here')"
                                @input="emit"
                            />
                        </b-form-group>
                        <b-form-group
                            :label="$t('Component(Label):description')"
                            :label-for="inputId('description', language)"
                        >
                            <b-form-textarea
                                :id="inputId('description', language)"
                                v-model="rule.translations[language.code].description"
                                rows="2"
                                :placeholder="$t('Component(Placeholder):description')"
                                @input="emit"
                            />
                        </b-form-group>
                    </b-tab>
                </b-tabs>
                <b-form-group
                    class="mt-1"
                    :label="$t('Component(Label):expression')"
                >
                    <b-form-textarea
                        v-model="expression"
                        :placeholder="$t('Component(Placeholder):type-here')"
                        @input="emit"
                    />
                </b-form-group>
                <ExpressionInterpreter
                    :expression="expression"
                    :explanation="explanation"
                />
            </b-col>
            <b-col
                cols="auto"
                class="pt-4"
            >
                <button
                    type="button"
                    class="btn btn-danger btn-sm"
                    @click="$emit('remove', rule)"
                >
                    <feather-icon icon="TrashIcon" />
                </button>
            </b-col>
        </b-row>
    </div>
</template>
